import React from 'react';
import styles from '../styles/HomePage.module.css';
import jamminLogo from '../images/jamminforjonah.png';


const CommunityGivebackSection = () => {
  return (
    <div className={styles.communityGivebackSection}>
      <div className={styles.musicWaveDivider}></div>
      
      {/* Add floating music notes for consistency with other sections */}
      <div className={styles.floatingNote1}></div>
      <div className={styles.floatingNote2}></div>
      
      <div className={styles.givebackContainer}>
        <h2>We Give Back to Our Community</h2>
        <p className={styles.sectionSubheadline}>Music has the power to change lives, and we're committed to making a difference</p>
        
        <div className={styles.givebackContent}>
          <div className={styles.givebackImageContainer}>
            <img 
              src="/images/jamminforjonah.png" 
              alt="Jammin' for Jonah" 
              className={styles.givebackImage}
            />
          </div>
          
          <div className={styles.givebackText}>
            <h3>Proud Partners with Jammin' for Jonah</h3>
            <p>
              At MakeMeSongs, we believe in the transformative power of music. That's why we're proud to partner 
              with Jammin' for Jonah, a live music event in honor of Jonah.
            </p>
            <p>
            We believe in the power of music to connect, heal, and provide new avenues of expression for children on the autism spectrum
            </p>
          </div>
        </div>
      </div>
      
      <div className={styles.musicWaveDivider}></div>
    </div>
  );
};

export default CommunityGivebackSection;